import ChartComponent from "./ChartComponent";
import React from 'react';

const Area = ({ area, width, height, data, curve, stroke, fill, opacity, name, animationDuration }) => {
    if (curve) {
        area.curve(curve);
    }

    function draw(chart) {
        const rectClipId = `${name}-rect-clip`;
        let rectClip = chart.append('clipPath')
            .attr('id', rectClipId)
            .append('rect')
            .attr('width', 0)
            .attr('height', height);
        chart.append('path')
            .datum(data)
            .attr('fill', fill)
            .attr('opacity', opacity)
            .attr('stroke', stroke)
            .attr('d', area)
            .attr('clip-path', `url(#${rectClipId})`);
        rectClip.transition()
            .duration(animationDuration * data.length)
            .attr('width', width);
    }

    return (
        <ChartComponent
            draw={draw}
        />
    )


}

export default Area;
